import { Button, Input, Tooltip } from "antd";
const { TextArea } = Input;
export const QuickFilterInfoForm = ({
  showDescriptionBox,
  titleInputValue,
  handleTitleInputChange,
  setShowDescriptionBox,
  filterTemplatePayload,
  setFilterTemplatePayload,
  handleModalCancel,
  handleSave,
  templateEdit,
}) => {
  let updatedTitle =
    titleInputValue?.length > 25
      ? titleInputValue.slice(0, 25)
      : titleInputValue;
  return (
    <div
      style={{
        overflow: "hidden",
        height: "auto",
        padding: "2rem",
        position: "fixed",
        bottom: 0,
        right: 0,
        width: "45rem", //52rem
        boxShadow: "0.1rem -0.4rem 2rem 1.4rem #c3cbd780 !important",
      }}
      className="box-shadow border-radius-8 bg-white p-15 box-shadow bg-white "
    >
      <div className="d-flex justify-content-between">
        <div style={{ minWidth: "27.5rem", width: "100%" }}>
          <div className="d-flex position-relative mb-15 floating-label-group header-brands">
            <Tooltip
              title={
                updatedTitle?.length > 25
                  ? "Max characters limit exeeded for title name"
                  : ""
              }
            >
              <Input
                style={{
                  border: "0.1rem solid #c3cbd7",
                  width: `${!showDescriptionBox ? "70%" : "100%"}`,
                  paddingRight: "5.2rem",
                }}
                showCount={false}
                id="outlined-required"
                required
                maxLength={25}
                placeholder={""}
                className="border-radius-4"
                value={updatedTitle}
                onChange={handleTitleInputChange}
              />
            </Tooltip>
            <label className="portlet-label floating-label">
              Name Quick Filter <span className="error">*</span>
            </label>
            <span
              className="text-gray position-absolute font-size12"
              style={{
                right: `${!showDescriptionBox ? "31%" : "1%"}`,
                bottom: "0.1rem",
              }}
            >
              {updatedTitle?.length > 0 ? updatedTitle?.length : "0"}
              /25
            </span>
            {!showDescriptionBox && (
              <div
                style={{ paddingLeft: "0.8rem" }}
                className="d-flex justify-content-between align-items-center pl-8 cursor-pointer"
              >
                <p
                  className="p-0 m-0"
                  style={{ color: "rgb(24, 94, 223)" }}
                  onClick={() => setShowDescriptionBox(true)}
                >
                  +
                  {templateEdit?.forDuplicate &&
                  filterTemplatePayload?.description
                    ? "Edit "
                    : "Add "}{" "}
                  description
                </p>
              </div>
            )}
          </div>

          {showDescriptionBox && (
            <div className="position-relative mb-15 floating-label-group header-brands">
              <TextArea
                rows={5}
                id="outlined-required"
                multiline
                className="border-radius-4 border-color"
                maxLength={150}
                value={filterTemplatePayload.description}
                onChange={(e) =>
                  setFilterTemplatePayload({
                    ...filterTemplatePayload,
                    description: e.target.value,
                  })
                }
                style={{
                  resize: "none",
                  padding: "0.8rem 1rem",
                  border: "0.1rem solid #c3cbd7",
                }}
                placeholder={"Enter Description"}
              />
              <label className="portlet-label floating-label">
                Description
              </label>
              <span
                className="text-gray position-absolute font-size12"
                style={{
                  right: "0.3rem",
                  bottom: "0.1rem",
                }}
              >
                {filterTemplatePayload?.description?.length > 0
                  ? filterTemplatePayload?.description?.length
                  : "0"}
                /150
              </span>
            </div>
          )}
        </div>
      </div>
      <div className="text-right">
        <Button
          type="button"
          className="btn_Clear mr-15"
          onClick={handleModalCancel}
        >
          Cancel
        </Button>
        <Tooltip
          title={
            !filterTemplatePayload?.payload?.length
              ? "No filter applied"
              : !filterTemplatePayload?.title
              ? "Enter quick filter name"
              : updatedTitle?.toLowerCase()?.trim() ===
                templateEdit?.originalTitle?.toLowerCase()?.trim()
              ? "Quick filter with same name alredy exists"
              : ""
          }
        >
          <Button
            type="primary"
            className="ant-btn-primary_blue"
            onClick={
              updatedTitle?.toLowerCase()?.trim() ===
              templateEdit?.originalTitle?.toLowerCase()?.trim()
                ? undefined
                : handleSave
            }
            style={{
              opacity: `${
                updatedTitle?.toLowerCase()?.trim() ===
                  templateEdit?.originalTitle?.toLowerCase()?.trim() ||
                !filterTemplatePayload?.title ||
                !filterTemplatePayload?.payload?.length
                  ? ".4"
                  : "1"
              }`,
            }}
          >
            Save
          </Button>
        </Tooltip>
      </div>
    </div>
  );
};
